var _style, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReadSearch = function SvgReadSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "read-search_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".read-search_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.9c-2.2-.8-4.6-1.3-7-1.4-.5 0-1-.5-1-1V2c0-.6.4-1 1-1q0 0 0 0c5.4.2 10 1.7 10 3.5 0-1.8 4.6-3.3 10-3.5.6 0 1 .4 1 1q0 0 0 0v15.5M11.5 4.5V5",
    className: "read-search_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.7C6.9 6 4.7 5.6 2.5 5.5M7 9.1q-2.25-.45-4.5-.6M5.9 11.9c-1.1-.2-2.3-.3-3.4-.4M6.1 14.9c-1.2-.2-2.4-.4-3.6-.4M16.5 6c1.3-.3 2.6-.4 4-.5M19.4 8.6c.4 0 .7-.1 1.1-.1",
    className: "read-search_svg__st0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13,
    r: 6,
    className: "read-search_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.8 17.3 5.7 5.7M11.5 13v-1.5c0-.3.2-.5.5-.5h3c.3 0 .5.2.5.5V13M13.5 11v5M12 16h3",
    className: "read-search_svg__st0"
  })));
};
export default SvgReadSearch;